import { REACT_APP_API_ORIGIN } from './constants';
import axios from 'axios'

class BankServices {
  async getBankAccounts() {
    return  await axios.get(`${REACT_APP_API_ORIGIN}/account/kcell`)
  }
  uploadFileRecognition(formData) {
    return axios.post(`${REACT_APP_API_ORIGIN}/recognition/async`, formData)
      .then(res => res.data)
  }
  deleteFileRecognition(id) {
    return axios.delete(`${REACT_APP_API_ORIGIN}/recognition/async/?id=${id}`);
  }
  checkProcessRecognition(id) {
    return axios.get(`${REACT_APP_API_ORIGIN}/recognition/result?id=${id}`)
      .then((res) => res.data)
  }
}

export default new BankServices()
